import { lazy,Route } from '@tanstack/router'

import type { RegisterSearch } from './register'
import { rootRoute } from './root'

const AffiliateAds = lazy(() => import('../pages/affiliate-ads'))

export const affiliateAdsRoute = new Route({
  getParentRoute: () => rootRoute,
  path: '/affiliate-ads',
  component: AffiliateAds,
  validateSearch: (search: Record<string, unknown>): RegisterSearch => {
    return search
  },
})
